import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../../context/UserContext';
import LoadingPulse from '../loading/LoadingPulse';

type ProtectedRouteProps = {
    children: React.ReactNode;
};

/**
 * Protected Route - Requires user to be logged in
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const { user, isLoading } = useUser();

    if (isLoading) {
        return <LoadingPulse />;
    }

    if (!user) {
        return <Navigate to="/" replace />;
    }

    return <>{children}</>;
};

export default ProtectedRoute;

